module.exports = __webpack_public_path__ + "93fdfaf93595bd21320aa716a6310135.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Sectra-Fine-Book-Italic.ttf
// module id = 45
// module chunks = 0